
























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { DbConfigs, SubmitForm } from '../store/modules/database/types';
import ActionButtons from './ActionButtons.vue';

@Component({
  components: {
    ActionButtons,
  },
})
export default class ConnectDatabase extends Vue {
  private inputType: string = 'password';
  @Prop(Boolean) private isDesktop!: boolean;
  @Prop(Function) private submitRemoteForm: any;
  @Prop(Function) private submitLocalForm: any;
  @Prop(Function) private setToDefault: any;
  @Prop(Function) private selectProfile!: (profile: string) => void;
  @Prop(Function) private connectProfile!: () => void;
  @Prop(Function) private refreshProfiles!: () => void;
  @Prop(Object) private submitForm!: SubmitForm;
  @Prop(Array) private regionList!: string[];
  @Prop(Object) private configs!: DbConfigs;
  @Prop(Array) private profiles!: Array<{ name: string; region: string }>;
  @Prop(String) private selectedProfile!: string;

  private mounted() {
    this.setToDefault();
  }
  private showSecretKey() {
    if (this.inputType === 'password') {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }
}
